import { render, staticRenderFns } from "./ThreeList.vue?vue&type=template&id=b85a4a0e"
import script from "./ThreeList.vue?vue&type=script&lang=js"
export * from "./ThreeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports